import { platformDetail } from '@/libs/api';

export default function title() {
  platformDetail().then(res => {
    let mess = res.data;
    // 页面title
    document.title = mess[2].value;
    // 页面图标
    var link =
      document.querySelector('link[rel*=\'icon\']') ||
      document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = mess[1].value;
    document.getElementsByTagName('head')[0].appendChild(link);
  });
}
title();
